import { render } from "./InstructionsModal.vue?vue&type=template&id=df2aa98e"
import script from "./InstructionsModal.vue?vue&type=script&lang=js"
export * from "./InstructionsModal.vue?vue&type=script&lang=js"

import "./InstructionsModal.vue?vue&type=style&index=0&id=df2aa98e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__